import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import LogoutIcon from "@mui/icons-material/Logout";

import DashboardIcon from "@mui/icons-material/Dashboard";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";

import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";

import PeopleIcon from "@mui/icons-material/People";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";

import DescriptionIcon from "@mui/icons-material/Description";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

import FolderSharedIcon from "@mui/icons-material/FolderShared";
import FolderSharedOutlinedIcon from "@mui/icons-material/FolderSharedOutlined";

import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";

import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";

import VerifiedIcon from "@mui/icons-material/Verified";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";

import PaymentsIcon from "@mui/icons-material/Payments";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";

import { logo, logo111 } from "../../assets/img";

const AdminProfileNavbar = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [popup, setPopup] = useState(false);
  const [docOpen, setDocOpen] = useState(false);
  const [salaryOpen, setSalaryOpen] = useState(false);
  const [genOpen, setGenOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  // ✅ ROUTE GROUPS
  const routeGroups = {
    dashboard: ["/admin/dashboard"],
    admin: ["/Admin", "/admin/add", "/admin/edit"],
    employee: ["/employee", "/employees-list"],
    document: ["/employeedocument", "/employee-documents-sent"],
    generate: [
      "/payslip-generated",
      "/offer-letter-generated",
      "/relieving-letter-generated",
    ],
    attendance: ["/attendance-list", "/employee-login-history"],
    confirm: ["/admin-pending-list"],
    salary: ["/salary-detail-list", "/all-employee-salary", "/create-salary-details"],
  };

  // ✅ CHECK ACTIVE ROUTE
  const isRouteActive = (group) => {
    return routeGroups[group].some((route) =>
      currentPath.startsWith(route)
    );
  };

  // ✅ AUTO OPEN SUBMENUS
  useEffect(() => {
    if (isRouteActive("document")) setDocOpen(true);
    if (isRouteActive("generate")) setGenOpen(true);
    if (isRouteActive("salary")) setSalaryOpen(true);
  }, [currentPath]);

  // ✅ TOGGLE SIDEBAR
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // ✅ LOGOUT
  const handleLogout = () => {
    navigate("/");
    setPopup(false);
  };

  return (
    <div className={sidebarOpen ? "sidebar" : "close_sidebar"}>

      {/* HEADER */}
      <header>
        <div className="image_text pointer d-flex ac-jc mt-2 Header_title">
          {sidebarOpen ? (
            <img src={logo} className="Login_title1" alt="logo" />
          ) : (
            <img src={logo111} className="logo111" alt="logo" />
          )}
        </div>
      </header>

      {/* TOGGLE BUTTON */}
      <div className="toggle_sidebar pointer" onClick={toggleSidebar}>
        {sidebarOpen ? (
          <KeyboardDoubleArrowLeftIcon className="lefticonarrow" />
        ) : (
          <KeyboardDoubleArrowRightIcon className="righticonarrow" />
        )}
      </div>

      {/* MENU */}
      <div className="menu_bar">
        <ul className="menu_links ps-0">

          {/* DASHBOARD */}
          <li className="nav_link" onClick={() => navigate("/admin/dashboard")}>
            <h4 className={`ps-3 ${isRouteActive("dashboard") ? "active_bar" : ""}`}>
              {isRouteActive("dashboard") ? (
                <DashboardIcon className="icon active_icon" />
              ) : (
                <DashboardOutlinedIcon className="icon" />
              )}
              <span className="text ps-1">Dashboard</span>
            </h4>
          </li>

          {/* ADMIN */}
          <li className="nav_link" onClick={() => navigate("/Admin")}>
            <h4 className={`ps-3 ${isRouteActive("admin") ? "active_bar" : ""}`}>
              {isRouteActive("admin") ? (
                <AdminPanelSettingsIcon className="icon active_icon" />
              ) : (
                <AdminPanelSettingsOutlinedIcon className="icon" />
              )}
              <span className="text ps-1">Admin</span>
            </h4>
          </li>

          {/* EMPLOYEES */}
          <li className="nav_link" onClick={() => navigate("/employees-list")}>
            <h4 className={`ps-3 ${isRouteActive("employee") ? "active_bar" : ""}`}>
              {isRouteActive("employee") ? (
                <PeopleIcon className="icon active_icon" />
              ) : (
                <PeopleOutlineIcon className="icon" />
              )}
              <span className="text ps-1">Employees</span>
            </h4>
          </li>

          {/* DETAILS UPLOAD */}
          <li className="nav_link">
            <h4
              className={`ps-3 ${isRouteActive("document") ? "active_bar" : ""}`}
              onClick={() => setDocOpen(!docOpen)}
            >
              {isRouteActive("document") ? (
                <DescriptionIcon className="icon active_icon" />
              ) : (
                <DescriptionOutlinedIcon className="icon" />
              )}
              <span className="text ps-1">Details Upload</span>
            </h4>

            {docOpen && (
              <ul className="submenu">
                <li
                  className={currentPath === "/employeedocument" ? "active_bar" : ""}
                  onClick={() => navigate("/employeedocument")}
                >
                  Document Upload
                </li>

                <li
                  className={currentPath === "/employee-documents-sent" ? "active_bar" : ""}
                  onClick={() => navigate("/employee-documents-sent")}
                >
                  Send Details
                </li>
              </ul>
            )}
          </li>

          {/* CERTIFICATE GENERATE */}
          <li className="nav_link">
            <h4
              className={`ps-3 ${isRouteActive("generate") ? "active_bar" : ""}`}
              onClick={() => setGenOpen(!genOpen)}
            >
              {isRouteActive("generate") ? (
                <FolderSharedIcon className="icon active_icon" />
              ) : (
                <FolderSharedOutlinedIcon className="icon" />
              )}
              <span className="text ps-1">Certificate Generate</span>
            </h4>

            {genOpen && (
              <ul className="submenu">
                <li
                  className={currentPath === "/payslip-generated" ? "active_bar" : ""}
                  onClick={() => navigate("/payslip-generated")}
                >
                  PaySlip
                </li>

                <li
                  className={currentPath === "/offer-letter-generated" ? "active_bar" : ""}
                  onClick={() => navigate("/offer-letter-generated")}
                >
                  Offer Letter
                </li>

                <li
                  className={currentPath === "/relieving-letter-generated" ? "active_bar" : ""}
                  onClick={() => navigate("/relieving-letter-generated")}
                >
                  Relieving Letter
                </li>
              </ul>
            )}
          </li>

          {/* ATTENDANCE */}
          <li className="nav_link" onClick={() => navigate("/attendance-list")}>
            <h4 className={`ps-3 ${isRouteActive("attendance") ? "active_bar" : ""}`}>
              {isRouteActive("attendance") ? (
                <EventAvailableIcon className="icon active_icon" />
              ) : (
                <EventAvailableOutlinedIcon className="icon" />
              )}
              <span className="text ps-1">Attendance</span>
            </h4>
          </li>

          {/* CONFIRM */}
          <li className="nav_link" onClick={() => navigate("/admin-pending-list")}>
            <h4 className={`ps-3 ${isRouteActive("confirm") ? "active_bar" : ""}`}>
              {isRouteActive("confirm") ? (
                <VerifiedIcon className="icon active_icon" />
              ) : (
                <VerifiedOutlinedIcon className="icon" />
              )}
              <span className="text ps-1">Confirm</span>
            </h4>
          </li>

          {/* SALARY */}
          <li className="nav_link">
            <h4
              className={`ps-3 ${isRouteActive("salary") ? "active_bar" : ""}`}
              onClick={() => setSalaryOpen(!salaryOpen)}
            >
              {isRouteActive("salary") ? (
                <PaymentsIcon className="icon active_icon" />
              ) : (
                <PaymentsOutlinedIcon className="icon" />
              )}
              <span className="text ps-1">Salary</span>
            </h4>

            {salaryOpen && (
              <ul className="submenu">
                <li
                  className={currentPath === "/salary-detail-list" ? "active_bar" : ""}
                  onClick={() => navigate("/salary-detail-list")}
                >
                  Salary History
                </li>

                <li
                  className={currentPath === "/all-employee-salary" ? "active_bar" : ""}
                  onClick={() => navigate("/all-employee-salary")}
                >
                  All Employee Salary
                </li>
              </ul>
            )}
          </li>
        </ul>
      </div>

      {/* LOGOUT */}
      <div className="d-flex ac-jb py-3 px-2 bg-primary2 pointer" onClick={() => setPopup(true)}>
        <h4 className="f4 mb-0 ms-4">Logout</h4>
        <LogoutIcon />
      </div>

      {/* LOGOUT POPUP */}
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p>Are you sure you want to logout?</p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={() => setPopup(false)} className="no-btn w-40">
                No
              </button>
              <button onClick={handleLogout} className="yes-btn w-40">
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminProfileNavbar;